import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import NumberFormat from "react-number-format";



const CommandeAddress= (props)=>{


    const [itemsTotPrice, setItemsTotPrice] = useState(0.0)


    useEffect(()=>{
        setItemsTotPrice(0.00)
    }, [props.products])

    useEffect(()=>{
        props.setOrderAddress({
            'company': props.structure.name,
            'address': props.structure.address,
            'addressbis' : props.structure.address2,
            'city':  props.structure.city,
            'cp' :  props.structure.cp,
        });

    }, [])


    return (
        <div className={"row"}>
            <div className="col">
                <h4 className={"font-weight-bold"}><span className={"badge badge-primary"}>2</span> Adresse de facturation : </h4>
                <div className={"card"}>
                    <div className="card-body">
                       <table className={'table table-borderless text-dark' }>
                           <tbody>
                           <tr>
                               <td >
                                   <h5 className={"font-weight-bold"}>{props.structure.name}</h5>
                               </td>
                           </tr>
                           <tr>
                               <td>
                                   {props.structure.siren}
                               </td>
                           </tr>
                           <tr>
                               <td>
                                   {props.structure.address}

                               </td>
                           </tr>
                           <tr>
                               <td>
                                   {props.structure.cp} {props.structure.city}
                               </td>
                           </tr>
                           </tbody>
                       </table>
                    </div>
                </div>
            </div>
        </div>
    )

}




const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        products: state.ShopCartReducer.products,
        structure: state.SubscribtionReducer.structureInfo,

    }
}


const mapDispatchTProps = dispatch => {
    return {
        emptyCart: (e) => dispatch( {type: 'EMPTY_CART'}),
        setOrderAddress: (e) => dispatch( {type: 'SET_ORDER_ADDRESS', data: e}),

    }
}

export default connect(mapStateToProps, mapDispatchTProps)(CommandeAddress);
